<div class="fg-dynamic-page-builder">
  <div class="row ">
    <div class="col-md-6">
    </div>

    <div class="container-fluid ">
      <mat-sidenav-container class="sidenav-container" autosize>
        <!-- Side Nav (Model List) -->
        <mat-sidenav #sidenav mode="side" opened>
          <div class="mt-3">
            <mat-tab-group>
              <!-- Tab 1: Models -->
              <mat-tab label="Models">
                <mat-toolbar>Models</mat-toolbar>

                @if (!localConfig.modelsAvailable) {
                  <div class="model-card">
                    <div class="card-title">Please Wait</div>
                    <div class="card-detail">Loading</div>
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                  </div>
                }

                @if (localConfig.modelsAvailable) {
                  <mat-form-field appearance="outline" class="search-box">
                    <input matInput placeholder="Search models..." [(ngModel)]="searchText" />
                  </mat-form-field>
                }

                <div class="card-grid">
                  @for (model of filteredModels(); track model) {
                    <div class="model-card" matRipple
                      (click)="onModelClick(model.code, model.name)">
                      <div class="card-title">{{ model.name }}</div>
                      <div class="card-detail"><strong>Category:</strong> {{ model.categoryCode }}</div>
                    </div>
                  }
                </div>
              </mat-tab>

              <!-- Tab 2: List Layout (Only in LIST mode) -->
              @if (localConfig.mode === 'LIST' && listVariation) {
                <mat-tab label="List Layout">
                  <div class="d-flex flex-column gap-3">
                    @for (variation of listVariation; track variation) {
                      <mat-card class="variation-card-vertical" [class.selected]="variation === selectedVariation"
                        (click)="selectVariation(variation)">
                        <mat-card-title class="card-title-ellipsis">
                          {{variation.viewVariation}}
                        </mat-card-title>
                        <div class="d-flex align-items-center">
                          <img mat-card-image class="preview-image" [src]="'/assets/img/charts/' + variation.img"
                            alt="{{ variation.viewName }}">
                            @if (variation === selectedVariation) {
                              <mat-icon class="checkmark">check_circle</mat-icon>
                            }
                          </div>
                        </mat-card>
                      }
                    </div>
                  </mat-tab>
                }

                <!-- Tab 3: Form Layout (Only in CREATE or EDIT mode) -->
                @if (localConfig.mode != 'LIST' ) {
                  <mat-tab label="Form Layout">
                    @for (variation of variationLayouts; track variation) {
                      @if (!variation.isDashboard) {
                        <div class="p-3">
                          <div class="formPreviewWrapper " (click)="switchView(variation)">
                            <h3 class="formPreviewHeading">{{ variation.label }}</h3>
                            <div class="p-2 model-card formPreview">
                              <form (keydown.enter)="$event.preventDefault()" #fgForm="ngForm">
                                <div fg-form-renderer [data]="{}" [templateConfig]="{}" [components]="variation.pagelayout">
                                </div>
                              </form>
                              <!-- Transparent overlay to disable interaction -->
                              <div class="formOverlay"></div>
                            </div>
                          </div>
                        </div>
                      }
                    }
                  </mat-tab>
                }
              </mat-tab-group>

            </div>

          </mat-sidenav>


          <!-- Main Content Area (Form) -->
          <mat-sidenav-content>
            <mat-toolbar>
              <button mat-icon-button (click)="sidenav.toggle()">
                <mat-icon>menu</mat-icon>
              </button>
              <span>{{ localConfig.modelName }}</span>
              <span class="spacer"></span>
              <!-- <button mat-icon-button (click)="generteBentoBoard()" matTooltip="Show Chart Variants">
              <mat-icon>featured_video</mat-icon>
            </button> -->
            <button mat-icon-button (click)="openChartVariantDialog()" matTooltip="Show Chart Variants">
              <mat-icon>bar_chart</mat-icon>
            </button>
            <!-- Variation Menu Button -->
            <button mat-icon-button [matMenuTriggerFor]="variationMenu" matTooltip="Choose Layout Variation">
              <mat-icon>featured_video</mat-icon>
            </button>
            <button  mat-icon-button  [matMenuTriggerFor]="languageMenu"
              matTooltipPosition="below">
              <mat-icon >language</mat-icon>

            </button>
            <mat-menu #languageMenu="matMenu" class="fg-more-toolbar-panel" backdropClass="fg-more-toolbar-menu"
              xPosition="before">
              <button mat-menu-item (click)="changeLanguage('en')">
                <span>🇬🇧 English</span>
              </button>
              <button mat-menu-item (click)="changeLanguage('ta')">
                <span>அ Tamil</span>
              </button>
              <button mat-menu-item (click)="changeLanguage('ar')">
                <span>؈ Arabic</span>
              </button>
            </mat-menu>

            <mat-menu #variationMenu="matMenu" class="previewMenu bento-menu">
              <div  class="previewMenu bento-menu"> <div class="previewMat">
                <h4>Generate Dashboard</h4>
              </div>

              <div class="group-label pt-1"> Bento Layouts</div>
              <mat-divider> </mat-divider>
              <div class="bento-grid">
                @for (dash of randomVariants; track dash) {
                  <div
                    class="bento-tile"
                    (click)="generteBentoBoard(dash.type, dash.columns); variationMenu.close()"
                    >
                    <mat-icon class="bento-icon">{{ dash.icon }}</mat-icon>
                    <div class="bento-label">{{ dash.label }}</div>
                  </div>
                }
              </div>

              <div class="group-label pt-1">2-Column Layouts</div>
              <mat-divider> </mat-divider>
              <div class="bento-grid">
                @for (dash of twoColumnVariants; track dash) {
                  <div
                    class="bento-tile"
                    (click)="generteBentoBoard(dash.type, dash.columns); variationMenu.close()"
                    >
                    <mat-icon class="bento-icon">{{ dash.icon }}</mat-icon>
                    <div class="bento-label">{{ dash.label }}</div>
                  </div>
                }
              </div>

              <div class="group-label pt-1">3-Column Layouts</div>
              <mat-divider> </mat-divider>
              <div class="bento-grid">
                @for (dash of threeColumnVariants; track dash) {
                  <div
                    class="bento-tile"
                    (click)="generteBentoBoard(dash.type, dash.columns); variationMenu.close()"
                    >
                    <mat-icon class="bento-icon">{{ dash.icon }}</mat-icon>
                    <div class="bento-label">{{ dash.label }}</div>
                  </div>
                }
              </div> </div>

            </mat-menu>



            <!-- Existing Buttons -->
            @if (localConfig.mode === 'LIST') {
              <button mat-icon-button matTooltip="Add" (click)="onAddClick()">
                <mat-icon>add</mat-icon>
              </button>
            }
            @if (localConfig.mode !== 'LIST') {
              <button mat-icon-button matTooltip="Back to List" (click)="onListlick()">
                <mat-icon>list</mat-icon>
              </button>
            }
          </mat-toolbar>


          @if (localConfig.mode== 'DASHBOARD'  && localConfig.dashboardPage) {
            <div class="main-content">
              <fg-form [formDataId]="localConfig.recordObject" [formSchema]="localConfig.dashboardPage"></fg-form>
            </div>
          }
          @if (localConfig.listPageInfo  && localConfig.mode=='LIST') {
            <div class="main-content">
              <div class="row">
                <div class="col-md-12">
                  <fg-form [formSchema]="localConfig.listPageInfo"></fg-form>
                </div>
              </div>
            </div>
          }

          @if (localConfig.mode== 'CREATE' || localConfig.mode== 'EDIT' || localConfig.mode== 'VIEW' && localConfig.pageInfo) {
            <div class="main-content"
              >
              @if (localConfig.pageInfo) {
                <div class="row">
                  <div class="col-md-12">
                    <fg-form [formDataId]="localConfig.recordObject" [formSchema]="localConfig.pageInfo"></fg-form>
                  </div>
                </div>
              }
            </div>
          }




        </mat-sidenav-content>
      </mat-sidenav-container>

    </div>
  </div>
</div>

@if (localConfig.mode=='LIST') {
  <button mat-fab class="fab-button" (click)="onAddClick()">
    <mat-icon>add</mat-icon>
  </button>
}
@if (localConfig.mode!='LIST') {
  <button mat-fab class="fab-button" (click)="onListlick()">
    <mat-icon>list</mat-icon>
  </button>
}